import { useEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const LeadGraphChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const root = am5.Root.new(chartRef.current);

    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
      })
    );

    

    // X Axis (labels)
    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "label",
        renderer: am5xy.AxisRendererX.new(root, {
          minGridDistance: 30,
        }),
      })
    );

    xAxis.get("renderer").grid.template.setAll({
    forceHidden: true,
    });

    xAxis.data.setAll(data);

    // Y Axis (values)
    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
      })
    );

    yAxis.get("renderer").labels.template.setAll({
  forceHidden: true,
});
    

    // Series (bars)
    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Leads",
        xAxis,
        yAxis,
        valueYField: "total",
        categoryXField: "label",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY}",
        }),
      })
    );

    series.data.setAll(data);

   series.bullets.push(() => {
  return am5.Bullet.new(root, {
    locationY: 1, // TOP of bar
    sprite: am5.Label.new(root, {
      text: "{valueY}",
      populateText: true,
      centerX: am5.p50,
      centerY: am5.p0, // anchor from bottom of label
      dy: -30, // push slightly above bar
      fill: am5.color("#000"), // better visibility than white
      fontSize: 16,
      fontWeight: "700",
    }),
  });
});


    // Styling
    series.columns.template.setAll({
        fill: am5.color("#105B3D"),
      cornerRadiusTL: 5,
      cornerRadiusTR: 5,
      strokeOpacity: 0,
    });

    series.appear(1000);
    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [data]);

  return <div ref={chartRef} style={{ width: "100%", height: "400px" }} />;
};

export default LeadGraphChart;